import React, { useEffect, useState, useRef } from "react";
import { Modal } from "react-bootstrap";
import { Button } from "../../themes/userq/Button/Button";
import { Text } from "../../themes/userq/Text/Text";
import { Icon } from "../../themes/userq/Icon/Icon";
import { Link } from "../../themes/userq/Link/Link";

export default function AddGiftCardModal(props) {
    const wrapperRef = useRef(null);

    function useOutsideAlerter(ref) {
        useEffect(() => {
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    if (event.target.nodeName == "DIV") {
                        closeModal();
                    }
                }
            }
            // Bind the event listener
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                // Unbind the event listener on clean up
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    }

    useOutsideAlerter(wrapperRef);

    const closeModal = () => {
        //setFormValues({ test_name: "" });
        // if status true then pass formvalue

        props.closeModal();
    };

    const handlePayout=()=>{
        props.requestPayout();
    }

    return (
        <Modal
            show={props.openModal}
            centered
            className="fade custom-modal-wrap add-payment-method-modal "
        >
            <Modal.Body ref={wrapperRef}>
                <div className="modal-inner-text">
                    <div className="modal-header-top">
                        <Text type="h3">Digital gift card</Text>
                        <button
                            type="button"
                            className="close"
                            onClick={() => {
                                closeModal(false);
                            }}
                            aria-label="Close"
                        >
                            <span aria-hidden="true">
                                <Icon value="Close" size="large" hover={true} />
                            </span>
                        </button>
                    </div>
                    <div className="tester_profole_guide_info mb-20">
                        <Text
                            type="body-text-3"
                            fontWeight="medium-font"
                            cssClasses="gray-text mb-20"
                        >
                           Your digital gift card will be sent to your registered email.
                        </Text>
                        <div className="payment-method-box d-block mx-auto">
                            <div className="payment-box-img">
                                <img
                                    src={
                                        process.env.REACT_APP_URL +
                                        "img/payment-cards.png"
                                    }
                                    alt="img"
                                />
                            </div>
                            <div className="payment-box-content px-20 py-12 text-center">
                                <Text
                                    type={"h2"}
                                    fontWeight={"semi-bold-font"}
                                    cssClasses={
                                        "secondary-purple-200 card-amount-text"
                                    }
                                >
                                    ${props.amount}
                                </Text>
                                <Text
                                    type={"body-text-3"}
                                    fontWeight={"medium-font"}
                                    cssClasses={"dark-text"}
                                >
                                    {props.userEmail}
                                </Text>
                                <Text
                                    type={"caption"}
                                    fontWeight={"medium-font"}
                                    cssClasses={"gray-text mt-12"}
                                >
                                    Powered by <img src={
                                        process.env.REACT_APP_URL +
                                        "img/tremendous.png"
                                    }/>
                                </Text>
                            </div>
                        </div>
                        <Text
                            type="body-text-3"
                            fontWeight="medium-font"
                            cssClasses="gray-text mt-40 mb-20"
                        >
                           You can redeem the voucher at various retailers, depending on your location. See the full list of stores  <Link
                                                           target={"_blank"}
                                                           url={
                                                               "https://www.tremendous.com/catalog/"
                                                           }
                                                       >
                                                           here
                                                       </Link>.
                        </Text>
                        <div className="d-flex mt-32">
                            <Button
                                type={"secondary"}
                                size={"large"}
                                label={"Cancel"}
                                cssclass={"mr-20"}
                                onClick={() => {
                                    closeModal(false);
                                }}
                            />
                            <Button
                                type={"primary"}
                                size={"large"}
                                label={"Confirm"}
                                onClick={() => {
                                   handlePayout();
                                }}
                                microLoading={props.isLoading?props.isLoading:false}
                            />
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}
